import { useState, useEffect, useContext } from "react";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import CustomButton from "../kits/button/CustomButton.jsx";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import ProgressBar from "../kits/progress/ProgressBar";
import TableCard from "../tableCard/TableCard.jsx";
import AddCue from "./AddCue.jsx";
import {
  EditIcon,
  PlusIcon,
  PlusSquareIcon,
  GridIcon,
} from "../kits/Icons.tsx";
import ColorSchema from "../kits/Color";

import ToastCustomize from "../kits/ToastCustomize";
import useAxios from "../../services/useAxios.tsx";
import { translateToReactSelect } from "../../utils/helperFunction.jsx";
import ProgressModal from "./ProgressModal.jsx";
import { NavLink } from "react-router-dom";
import Helmet from "react-helmet";
import { searchFunc } from "../../utils/helperFunction";
import SearchInputContext from "../../Search/SearchInput";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

export default function Campaign() {
  const { userInfo } = useContext(AuthenticationContext);

  const { execute: campaignListApi } = useAxios("api2/campaign_list");
  const { execute: suitableLeads } = useAxios("api2/suitable_leads");
  const { execute: createLead } = useAxios("api2/create_lead");
  const { execute: findSteps } = useAxios("api/Find_step");
  const { execute: findCustomer } = useAxios("api2/Find_Customers");
  const [steps, setSteps] = useState([]);
  const [users, setUsers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [searchContent, setSearchContent] = useState([]);
  const { searchInput } = useContext(SearchInputContext);
  useEffect(() => {
    let temp = searchFunc(searchInput, searchContent);
    setContent(temp);
  }, [searchInput]);

  const convertTimestampToDate = (timeStamp) => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian,
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };

  const defineStatus = (state) => {
    let status = "";
    switch (state) {
      case "0":
        status = "شروع نشده";
        break;
      case "1":
        status = "در حال اجرا";
        break;
      case "2":
        status = "انجام شده";
        break;

      default:
        status = "در حال اجرا";
        break;
    }
    return status;
  };

  const handleLead = (campaignId, progressbarShow, leadsCount, done, x) => {
    let temp = [...content];

    for (let i = 0; i < temp.length; i++) {
      if (campaignId == temp[i].id) {
        temp[i] = {
          ...temp[i],
          progressbarShow: progressbarShow,
          leadsCount: leadsCount,
          done: x + done,
        };

        if (temp[i].leadsCount == temp[i].done) {
          // temp[i] = { ...temp[i], done: 0 };

          ToastCustomize({
            mainText: "سرنخ با موفقیت اضافه شد",
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        }
      }
      console.log("yes2", progressbarShow);
    }

    setContent(temp);
  };
  const addLeads = (campaignId) => {
    suitableLeads({ campaign_id: campaignId }).then((data) => {
      if (data.customers.length == 0) {
        ToastCustomize({
          mainText: "سرنخ جدیدی برای این کمپین موجود نیست",
          duration: 3000,
          toastType: "info",
          color: "info",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        handleLead(campaignId, true, data.customers.length, 0, 0);

        setLeads(data.customers);

        for (let i = 0; i < data.customers.length + 1; i++) {
          const test = async () => {
            await createLead({
              campaignId: campaignId,
              customerId: data?.customers[i]?.customers__id,
              // usertoken:
              //   "JJD3KtVvjLQiIEEBh35zik7AoIQfhDVnqsqZq*13*PowkjcGf*13*GRVXqwHY5FRZHoc1Y"
            }).then((data1) => {
              if (data1.status == 1) {
                handleLead(campaignId, true, data.customers.length, 1, i);
              }
            });
          };
          test();
        }
      }
    });
  };
  const addCueApi = (campaignId) => {
    suitableLeads({ campaign_id: campaignId }).then((data) => {
      if (data.status == "1") {
        for (let j = 0; j < data?.customers.length; j++) {
          let object = {};
          object.value = data?.customers[j].customers__id;
          object.label =
            data?.customers[j].firstname + " " + data?.customers[j].lastname;

          users.push(object);
        }
      }
    });
    findSteps({ conditions: `campaign_id/=/${campaignId}@@status/=/2` }).then(
      (data) => {
        setSteps(translateToReactSelect(false, data, "title", true));
        // if (data != "") {
        //   for (let k = 0; k < data?.steps.length; k++) {
        //     let object = {};
        //     object.value = data?.steps[k].id;
        //     object.label = data?.steps[k].title;
        //     steps.push(object);
        //   }
        // }
      }
    );
    findCustomer().then((result) => {
      setUsers(translateToReactSelect(false, result, "company_name", true));
    });
  };
  const returnJSX = (campaignId, val) => {
    return (
      <div className="d-flex justify-content-center">
        {userInfo.userRoll.includes(22) && (
          <CustomTooltip
            title="ویرایش"
            placement="top"
            color="secondary_custom"
          >
            <div>
              <NavLink
                to={`/single-campaign/${campaignId}`}
                // target="_blank"
                className="text-decoration-none"
              >
                <CustomButton
                  className="shadow-none"
                  onClick={() => {
                    console.log("campaignId", campaignId);
                  }}
                >
                  <EditIcon color="white"></EditIcon>
                </CustomButton>{" "}
              </NavLink>
            </div>
          </CustomTooltip>
        )}

        <div
        // onClick={() => {
        //   addCueApi(campaignId);
        // }}
        >
          <AddCue
            campaignId={campaignId}
            title={val.title}
            steps={steps}
            users={users}
            addCueApi={addCueApi}
          />
        </div>

        <ProgressModal
          addLeads={addLeads}
          leads={leads}
          campaignId={campaignId}
          val={val}
        />
      </div>
    );
  };

  const [header, setHeader] = useState([
    {
      type: "title",
      title: "عنوان",
      name: "title",
    },
    { type: "description", title: " توضیحات ", name: "description" },
    {
      type: "title",
      title: "زمان ثبت",
      name: "mtm",
    },
    {
      type: "title",
      title: "زمان شروع",
      name: "starttm",
    },
    {
      type: "title",
      title: "زمان پایان",
      name: "endtm",
    },
    {
      type: "title",
      title: "وضعیت",
      name: "status",
    },
    {
      // type: "operation",
      title: " عملیات ",
      name: "operation",
    },
  ]);
  const [content, setContent] = useState([
    {
      title: "",
      description: "",
      // starttm: "",
      // endtm: "",
      // status: "",
      progressbarShow: false,
      leadsCount: 0,
      done: 0,
    },
  ]);

  useEffect(() => {
    campaignListApi().then((data) => {
      let temp = [...data.campaigns];

      for (let i = 0; i < temp.length; i++) {
        temp[i] = {
          ...temp[i],
          progressbarShow: false,
          leadsCount: 0,
          done: 0,
        };
      }
      setContent(temp);
      setSearchContent(temp.reverse());
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>لیست کمپین ها</title>
      </Helmet>
      {userInfo.userRoll.includes(21) && (
        <div className="mx-5 my-4 d-flex">
          <NavLink
            to="/single-campaign"
            className=" text-decoration-none"
            // target="_blank"
          >
            <CustomButton color="info" onClick={() => {}}>
              ساخت کمپین
            </CustomButton>
          </NavLink>
        </div>
      )}
      {userInfo.userRoll.includes(20) &&
        content?.map((val) => {
          return (
            <TableCard
              column={
                // val.progressbarShow && val.leadsCount > 0
                //   ? [
                //       ...header,
                //       { type: "title", title: "پیشرفت", name: "progress" },
                //     ]
                //   :
                header
              }
              content={
                val.progressbarShow && val.leadsCount > 0
                  ? {
                      ...val,
                      operation: returnJSX(val.id, val),
                      mtm:
                        val.mtm != "" ? convertTimestampToDate(val.mtm) : "---",
                      starttm:
                        val.starttm != ""
                          ? convertTimestampToDate(val.starttm)
                          : "---",
                      endtm:
                        val.endtm != ""
                          ? convertTimestampToDate(val.endtm)
                          : "---",
                      status: defineStatus(val.status),
                      // progress:
                      //   val.leadsCount != val.done ? (
                      //     <ProgressBar
                      //       progressbarShow={val.progressbarShow}
                      //       color={ColorSchema.success_custom}
                      //       width={8}
                      //       total={leads?.length}
                      //       done={val.done}
                      //     />
                      //   ) : (
                      //     "تکمیل شده"
                      //   ),
                    }
                  : {
                      ...val,
                      operation: returnJSX(val.id, val),
                      mtm: convertTimestampToDate(val.mtm),
                      starttm: convertTimestampToDate(val.starttm),
                      endtm: convertTimestampToDate(val.endtm),
                      status: defineStatus(val.status),
                    }
              }
              bg={"primary_custom"}
              widthParent={"80%"}
              showSelect="false"
            ></TableCard>
          );
        })}
    </div>
  );
}
